import { reactive } from 'vue'

/**
 * Registro in-memory delle durate delle chiamate API (millisecondi), alimentato
 * dagli interceptor di `apiClient`. Usato dal badge diagnostico dei widget
 * dashboard (visibile SOLO in sessione passpartout) per capire quale widget
 * è lento. Nessuna persistenza, nessun invio al server: solo RAM del tab.
 */
export interface ApiTiming {
  /** Path senza query string (es. /api/v2/dashboard/summary). */
  path: string
  method: string
  ms: number
  status: number
  at: number
}

const MAX_ENTRIES = 300

/** Registro reattivo (append-only con cap): i computed che lo leggono si aggiornano da soli. */
export const apiTimings = reactive<ApiTiming[]>([])

export function recordApiTiming(t: ApiTiming): void {
  apiTimings.push(t)
  if (apiTimings.length > MAX_ENTRIES) {
    apiTimings.splice(0, apiTimings.length - MAX_ENTRIES)
  }
}

/**
 * Ultima misura per ciascun path distinto che inizia con uno dei prefissi dati.
 * Ritorna null se nessuna chiamata corrisponde (widget senza traffico).
 */
export function latestTimingsFor(prefixes: string[]): ApiTiming[] | null {
  if (!prefixes.length) return null
  const latest = new Map<string, ApiTiming>()
  for (const t of apiTimings) {
    if (prefixes.some((p) => t.path.startsWith(p))) {
      latest.set(`${t.method} ${t.path}`, t)
    }
  }
  return latest.size ? [...latest.values()] : null
}
